import type { Asset } from 'src/types'

type AssetRequiredFields = Pick<Asset, 'lat' | 'lon' | 'subscribers' | 'prinexId' | 'hubId'>

interface AssetWithError extends Asset {
  error: string | null
}

/**
 * Extract requiered fields from an Asset
 * @param {Asset} asset Asset to check
 * @returns {AssetRequieredFields} Required fields from an Asset
 */
function getRequiredFields (asset: Asset): AssetRequiredFields {
  const { lat, lon, subscribers, prinexId, hubId } = asset

  return ({
    lat,
    lon,
    prinexId,
    subscribers,
    hubId
  })
}

/**
 * Get the first error in the asset
 * @param {Asset} asset Asset malformed with required fields in null or undefined
 * @returns {string} The first error in the asset, prepared to translate
 */
function getErrorFromAsset (asset: Asset): string {
  const requiredFields = getRequiredFields(asset)

  const errors = Object.entries(requiredFields)
    .filter(([, value]) => value === null || value === undefined)
    .map(([key]) => key)

  const [firstError] = errors

  return `hidden-assets.error.${firstError}`
}

/**
 * Extract the first error from a list of malformed assets
 * @param {Asset[]} assets List of assets to check
 * @returns {ActiveWithError[]} List of assets with the first error found
 */
export function checkAssets (assets: Asset[]): AssetWithError[] {

  const assetsWithError = assets.map((asset): AssetWithError => {
    const error = getErrorFromAsset(asset)

    return ({
      ...asset,
      error
    })
  })

  return assetsWithError
}
